import { screen } from 'components/styles/variables';
import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  phoneNumber: string;
  className?: string;
  onClick?: () => void;
}

export default function PhoneLinkOnlyClickableOnMobile({
  phoneNumber,
  children,
  className,
  onClick,
}: Props): JSX.Element {
  return (
    <>
      <a
        href={`tel: ${phoneNumber}`}
        className={classNames('clickable', className)}
        target="_parent"
        onClick={onClick}
      >
        {children}
      </a>
      <button className={classNames('unclickable', className)} onClick={onClick}>
        {children}
      </button>
      <style jsx>{`
        .unclickable {
          display: none;
        }
        .clickable {
          display: flex;
        }

        @media (min-width: ${screen.smMin}) {
          .clickable {
            display: none;
          }

          .unclickable {
            display: flex;
            background: none;
            color: inherit;
            border: none;
            padding: 0;
            font: inherit;
            cursor: pointer;
            outline: inherit;
            text-align: inherit;
          }
        }
      `}</style>
    </>
  );
}
